// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__MkYvX","avatar":"style_avatar__2AH3Z","menuIcon":"style_menuIcon__jN_ms"};